export default __webpack_public_path__ + "static/media/eagle coin.f3bb8313.svg";